var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutubeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9518 5.41504C18.3327 6.90004 18.3327 10 18.3327 10C18.3327 10 18.3327 13.1 17.9518 14.585C17.7402 15.4059 17.121 16.0517 16.3368 16.27C14.9127 16.6667 9.99935 16.6667 9.99935 16.6667C9.99935 16.6667 5.08852 16.6667 3.66185 16.27C2.87435 16.0484 2.25602 15.4034 2.04685 14.585C1.66602 13.1 1.66602 10 1.66602 10C1.66602 10 1.66602 6.90004 2.04685 5.41504C2.25852 4.59421 2.87768 3.94837 3.66185 3.73004C5.08852 3.33337 9.99935 3.33337 9.99935 3.33337C9.99935 3.33337 14.9127 3.33337 16.3368 3.73004C17.1243 3.95171 17.7427 4.59671 17.9518 5.41504ZM8.33268 12.9167L13.3327 10L8.33268 7.08337V12.9167Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeLogo);
export default __webpack_public_path__ + "static/media/youtube-logo.b195cdaf.svg";
export { ForwardRef as ReactComponent };